export { default as TbaAnalysisSideMenu } from './connector';
export * from './TbaAnalysisSideMenu.proptype';
